import dayjs from "dayjs";
import { useEffect, useState } from "react";

const useClubDeadline = (
  managerMode: number,
  devPort: string,
  clubId: string,
  gameDate: string
) => {
  const [isDeadlinePassed, setIsDeadlinePassed] = useState(false);
  const [deadline, setDeadline] = useState<Date>();
  const [hasDeadline, setHasDeadline] = useState(false);
  console.log("game Date", gameDate);
  useEffect(() => {
    const club_deadline_fetch = devPort + "club_signup_deadline/" + clubId;
    console.log(club_deadline_fetch);
    fetch(club_deadline_fetch)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        console.log(data);
        if (data && data[0]) {
          // Check if a deadline is actually configured
          // data[0][0] is hours format, data[0][1] is day/time format
          const hasHoursDeadline = data[0][0] !== null && data[0][0] !== undefined && data[0][0] !== 0;
          const hasDayTimeDeadline = data[0][1] !== null && data[0][1] !== undefined;
          
          if (!hasHoursDeadline && !hasDayTimeDeadline) {
            // No deadline configured - don't show the banner
            setHasDeadline(false);
            return;
          }
          
          console.log(data[0][0]);
          console.log(gameDate);
          const parsedGameDate = new Date(
            Date.parse(gameDate.replace(/(\d+)(st|nd|rd|th)/, "$1"))
          );
          
          // Check if parsed game date is valid
          if (isNaN(parsedGameDate.getTime())) {
            console.log("Invalid game date, not showing deadline");
            setHasDeadline(false);
            return;
          }
          
          const deadlineDate = new Date(parsedGameDate);
          const currentTime = new Date();

          if (hasHoursDeadline) {
            // Hours before event format
            deadlineDate.setHours(deadlineDate.getHours() - data[0][0]);
          } else {
            // Day and time format
            const deadlineDateDB = dayjs(data[0][1]);
            // Get day of week (0-6, where 0 is Monday)
            const dayOfWeek = (deadlineDateDB.day() + 6) % 7 +1; // Convert Sunday=0 to Monday=0 

            const gameDay = parsedGameDate.getDay(); // 0-6 (Sunday-Saturday).
            const deadlineDayNumber = dayOfWeek;
            const deadlineHour = deadlineDateDB.hour();
            const deadlineMinute = deadlineDateDB.minute();
            console.log("DEADLINE!!!")
            console.log(gameDay);
            console.log(deadlineDayNumber);
            console.log(deadlineHour);
            console.log(deadlineMinute);
            console.log(deadlineDate);
            // Calculate days to subtract
            let daysToSubtract = gameDay - deadlineDayNumber;
            if (daysToSubtract <= 0) {
              daysToSubtract += 7; // Wrap around to previous week
            }

            // Set the deadline date
            deadlineDate.setDate(deadlineDate.getDate() - daysToSubtract);
            deadlineDate.setHours(deadlineHour, deadlineMinute, 0, 0);
          }

          console.log("current time", currentTime);
          console.log(deadlineDate);
          console.log(currentTime >= deadlineDate);
          setIsDeadlinePassed(
            managerMode !== -1 && currentTime >= deadlineDate
          );
          setDeadline(deadlineDate);
          setHasDeadline(true);
        } else {
          // No deadline data returned
          setHasDeadline(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching deadline:", error);
        setHasDeadline(false);
      });
  }, [devPort, clubId, managerMode, gameDate]);

  return { isDeadlinePassed, deadline, hasDeadline };
};

export default useClubDeadline;
